export default "__VITE_ASSET__IM1KlLH4__"